import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";

import { getData } from "features/dinamic";


interface RelacionState {
    status: string;
    error: string;
    relacionList: any[],
    relacionListActive: any[],
    relacion: {
        idRelacion: number | null;
        nombre: string | null;
    }

}

const initialState: RelacionState = {
    status: 'idle',
    error: '',
    relacionList: [],
    relacionListActive: [],
    relacion: {
        idRelacion: null,
        nombre: null
    }
}

export const fetchRelacion = createAsyncThunk('fetchRelacion', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 51;
    const { result, message, data } = await getData({ idsp }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});

export const fetchRelacionActive = createAsyncThunk('fetchRelacionActive', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 52;
    const { result, message, data } = await getData({ idsp }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});


export const relacionSlice = createSlice({
    name: 'relacion',
    initialState,
    reducers: {
        setRelacionList: (state, action) => {
            state.relacionList = action.payload;
        },
        setRelacionListActive: (state, action) => {
            state.relacionListActive = action.payload;
        },
        setRelacion: (state, action) => {
            state.relacion = !action.payload ? initialState.relacion : action.payload;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(fetchRelacion.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchRelacion.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.relacionList = data ? data : [];

            })
            .addCase(fetchRelacion.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
            .addCase(fetchRelacionActive.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchRelacionActive.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.relacionListActive = data ? data : [];

            })
            .addCase(fetchRelacionActive.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
    }
})

export const selectRelacionList = (state: RootState) => state.relacion.relacionList;
export const selectRelacionListActive = (state: RootState) => state.relacion.relacionListActive;
export const selectRelacion = (state: RootState) => state.relacion.relacion;

export const { setRelacionList, setRelacionListActive, setRelacion } = relacionSlice.actions;

export default relacionSlice.reducer;



